module.exports = __webpack_public_path__ + "static/img/大疆 DJI Air 3S 无人机.3d8643aa.png";